module.exports = __webpack_public_path__ + "static/TimothyDeakin_lab-a149ca1ee72e7b01ce49db100b0be224.png";